import React, { Component } from 'react';
import axios from 'axios';
import { Tabs, Tab } from 'react-bootstrap';
import { __FORCE_SESSIONS_UPDATE_ALWAYS__ } from '../../consts/consts';
import SessionByDay from './SessionByDay'
import "./style.css";
import { FormattedDate } from 'react-intl';
import Storage from '../Storage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import IntlMessages from '../../helpers/IntlMessages';
import { Multiselect } from 'multiselect-react-dropdown';
import Spinner from 'react-bootstrap/Spinner'
import { getPictureOrTransparent } from '../../helpers/Utils';
import ProgrammeGridView from '../ProgrammeGridView';
import SpeakerFilters from './SpeakerFilter/SpeakerFilters';
import Utils from '../Utils';

class Sessions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activityList: [],
            activityFilterList: [],
            sessionDays: [],
            daysWithActivities: [],
            speakerList: [],
            actTracks: [],
            actTypes: [],
            trackFilters: [],
            typeFilters: [],
            loading: true,
            showGridView: false,
            searchTerm: "",
            selectedSpeakersFilter: [],
            showSpeakerFilters: false,
        };
    }

    _performClickAction(activity, topHeight, roomLink) {
        //traer los speakers de la actividad y el room con los datos en caso de que
        //var actSpeakers = this.state.speakerList.filter( o => o.sessionIds.includes(parseInt(activity.id)))
        var actSpeakers = this.state.speakerList.filter(spk => spk.speakerActivity.find(act => act.idActivity == parseInt(activity.id)))
        this.props.clickAction(activity, actSpeakers, topHeight, roomLink)
    }




    componentDidMount() {

        let programme = Storage.getProgramme();
        if (!programme || __FORCE_SESSIONS_UPDATE_ALWAYS__) {
            const eventId = Storage.getIdEvent();
            axios.get(`https://api.kingconf.com/v3.0/events/${eventId}/eventPackage/`).then(({ data }) => {
                const { speakerModelList, sessionModelList, sessionTrackModelList, sessionTypeModelList, eventModelV3, MainMenuJson } = data;
                const { mainScheduleNr, homeHeaderPictureId, id } = eventModelV3;
                

                const requestVirtualBasicInfo = axios.get("https://api.kingconf.com/v3.0/events/" + id + "/virtualBasicInfo")
                const requestRooms = axios.get('https://api.kingconf.com/v3.0/events/' + id + '/rooms')
                axios.all([requestVirtualBasicInfo, requestRooms]).then(axios.spread((...responses) => {
                        var respVirtualBasicInfo = responses[0].data
                        var respRooms = responses[1].data

                        Storage.saveEventBasicInfo(respVirtualBasicInfo)
                        Storage.saveRoomsInfo(respRooms)
                        if (respVirtualBasicInfo.virtualCssStyles) {
                            Utils.insertCss(respVirtualBasicInfo.virtualCssStyles);
                        }
                    })
                )
            

             
                try {
                    const parsedMainMenuJson = JSON.parse("{" + MainMenuJson + "}");
                    console.log(parsedMainMenuJson);
                    window.localStorage.setItem('MMJson', "{" + MainMenuJson + "}");
                } catch (e) {
                    console.log(e, MainMenuJson);
                }
                var speakers = speakerModelList.filter(s => s.deleted == 0);
                var activityTracks = sessionTrackModelList;
                var activityTypes = sessionTypeModelList;
                var sessions = sessionModelList.filter(act => act.deleted == 0 && act.scheduleNr == mainScheduleNr);
                Storage.setProgramme(sessions, speakers, activityTracks, activityTypes);
                this.setSessions(sessions, speakers, activityTracks, activityTypes);
                window.localStorage.setItem('pictureLogoId', homeHeaderPictureId);
                this.setState({ logoPictureId: homeHeaderPictureId });
            })
        }
        else {
            var speakers = programme.speakers
            var activityTracks = programme.activityTracks;
            var activityTypes = programme.activityTypes;
            var sessions = programme.sessions;
            this.setSessions(sessions, speakers, activityTracks, activityTypes);
        }


    }

    setSessions(sessions, speakers, activityTracks, activityTypes) {
        var sessionDays = sessions.map(activity => { return activity.startDateTime.split('T')[0] })
        var sessionsDaysSet = new Set(sessionDays.sort());
        var daysFiltered = [...sessionsDaysSet];
        //Si no pongo +'T00:00:00' parsea mal, un dia antes
        for (var i = 0; i < daysFiltered.length; i++) {
            daysFiltered[i] += 'T00:00:01';
        }

        this.setState({
            activityList: sessions,
            activityFilterList: sessions,
            daysWithActivities: sessions,
            sessionDays: daysFiltered,
            speakerList: speakers,
            actTracks: activityTracks,
            actTypes: activityTypes,
            loading: false,
        })

    }

    _getDisplayValueOptionForFilter() {
        switch (this.props.locale) {
            case "en":
                return "name_EN"
            case "es":
                return "name_ES"
            case "pt":
                return "name_PT"
            case "fr":
                return "name_FR"
            default: return "name"
        }
    }

    _handleTrackFilterSelect = (selectedList) => {
        // const { activityList, typeFilters } = this.state
        // var acts = [];

        // //GEC: Si hay Tracks, filtramos por Tracks y por cada Type (si hay)
        // if (selectedList.length != 0)
        //     selectedList.forEach(track => {
        //         var actsOfThisTrack = activityList.filter(act => act.idActivityTrack == track.id)
        //         typeFilters.length != 0 ?
        //             typeFilters.forEach(type => {
        //                 var actsOfThisType = actsOfThisTrack.filter(act => act.idActivityType == type.id && act.idActivityTrack == track.id)
        //                 actsOfThisType.map(act => acts.push(act))
        //             })
        //             :
        //             actsOfThisTrack.map(act => acts.push(act))
        //     })
        // //GEC: Si no hay Tracks filtramos solo por Types.
        // else if (typeFilters.length != 0)
        //     typeFilters.forEach(type => {
        //         var actsOnlyType = activityList.filter(act => act.idActivityType == type.id)
        //         actsOnlyType.map(act => acts.push(act))
        //     })

        // //GEC: Si no hay ninguno de los dos mostramos todas las actividades.
        // if (selectedList.length == 0 && typeFilters.length == 0)
        //     acts = activityList;
        console.log('type filter list', selectedList);
        this.setState(prevState => {
            console.log('setstates', prevState, selectedList);
            return {
                // activityFilterList: acts,
                trackFilters: selectedList
            }
        })
    }

    _handleTypeFilterSelect = (selectedList) => {
        // const { activityList, trackFilters } = this.state
        // var acts = [];
        // //GEC: Si hay Types, filtramos por Types y por cada Track (si los hay).
        // if (selectedList.length != 0)
        //     selectedList.forEach(type => {
        //         var actsOfThisType = activityList.filter(act => act.idActivityType == type.id)
        //         trackFilters.length != 0 ?
        //             trackFilters.forEach(track => {
        //                 var actsOfThisTrack = actsOfThisType.filter(act => act.idActivityTrack == track.id && act.idActivityType == type.id)
        //                 actsOfThisTrack.map(act => acts.push(act))
        //             })
        //             :
        //             actsOfThisType.map(act => acts.push(act))
        //     })
        // //GEC: Si no hay Types filtramos solo por Tracks.
        // else if (trackFilters.length != 0)
        //     trackFilters.forEach(track => {
        //         var actsOnlyTrack = activityList.filter(act => act.idActivityTrack == track.id)
        //         actsOnlyTrack.map(act => acts.push(act))
        //     })

        // //GEC: Si no hay ninguno de los dos, enviamos todas las actividades.
        // if (selectedList.length == 0 && trackFilters.length == 0)
        //     acts = activityList;
        this.setState({
            typeFilters: selectedList
        });

    }

    _getDateForSessionByDay(date) {
        return <FormattedDate
            value={date}
            month="long"
            day="numeric"
            weekday="long"

        />
    }
    _getActivitiesForTheDay(day, actsArray) {
        var moment = require("moment-timezone");

        var actsFilteredByDay = actsArray
            .filter(function (activity) {
                return moment(activity.startDateTime).isSame(day, "day");
            })
            .sort((a, b) => a.startDateTime.localeCompare(b.startDateTime));
        return actsFilteredByDay;
    }

    // componentWillUpdate(_, prevState) {
    //     const { trackFilters, typeFilters, searchTerm, selectedSpeakersFilter, sessionDays } = this.state;
    //     console.log(typeFilters, prevState.typeFilters, typeFilters === prevState.typeFilters);
    //     if (trackFilters !== prevState.trackFilters || typeFilters !== prevState.typeFilters || searchTerm !== prevState.searchTerm || selectedSpeakersFilter !== prevState.selectedSpeakersFilter) {
    //         console.log('filters change');
    //         const newFilteredList = this.handleFilterAndSearch();
    //         console.log(newFilteredList);
    //         const daysWithActivities = sessionDays.map(day => this._getActivitiesForTheDay(day, newFilteredList)).filter(item => item.length);
    //         console.log('days with activities', daysWithActivities);
    //         this.setState({
    //             activityFilterList: newFilteredList,
    //             daysWithActivities: daysWithActivities,
    //         });
    //     }
    // }

    // componentDidUpdate(prevProps, prevState) {
    //     // if (this.state.activityFilterList !== prevState.activityFilterList) {
    //     //     const { sessionDays, activityFilterList } = this.state;
    //     //     this.setState({ daysWithActivities: daysWithActivities })
    //     // }
    //     const { trackFilters, typeFilters, searchTerm, selectedSpeakersFilter, sessionDays } = this.state;
    //     console.log(typeFilters, prevState.typeFilters, typeFilters === prevState.typeFilters);
    //     if (trackFilters !== prevState.trackFilters || typeFilters !== prevState.typeFilters || searchTerm !== prevState.searchTerm || selectedSpeakersFilter !== prevState.selectedSpeakersFilter) {
    //         console.log('filters change');
    //         const newFilteredList = this.handleFilterAndSearch();
    //         console.log(newFilteredList);
    //         const daysWithActivities = sessionDays.map(day => this._getActivitiesForTheDay(day, newFilteredList)).filter(item => item.length);
    //         console.log('days with activities', daysWithActivities);
    //         this.setState({
    //             activityFilterList: newFilteredList,
    //             daysWithActivities: daysWithActivities,
    //         });
    //     }
    // }

    handleSearchBar = (e) => {
        const { value } = e.target;
        this.setState({
            searchTerm: value,
        });
    }

    handleFilterAndSearch = () => {
        const { activityList, trackFilters, typeFilters, selectedSpeakersFilter, searchTerm } = this.state;
        let filteredActivities = activityList;
        if (trackFilters?.length) {
            const trackIdList = trackFilters.map(track => Number(track.id));
            filteredActivities = filteredActivities.filter(activity => {
                return trackIdList.includes(activity.idActivityTrack);
            });
        }

        if (typeFilters?.length) {
            const typeIdList = typeFilters.map(type => Number(type.id));
            filteredActivities = filteredActivities.filter(activity => {
                return typeIdList.includes(Number(activity.idActivityType))
            });
        }

        if (selectedSpeakersFilter?.length) {
            filteredActivities = filteredActivities.filter(activity => {
                const { speakerIds } = activity;
                let foundSpeaker = false;
                selectedSpeakersFilter.forEach(speaker => {
                    if (speakerIds.includes(Number(speaker))) {
                        foundSpeaker = true;
                    }
                });
                return foundSpeaker;
            });
        }

        if (searchTerm) {
            filteredActivities = filteredActivities.filter(activity => {
                const { title } = activity;
                const normalizedTitle = title.toLowerCase();
                const normalizedSearchterm = searchTerm.toLowerCase();
                return normalizedTitle.includes(normalizedSearchterm);
            });
        }
        return filteredActivities;
    }

    handleSpeakerFilterSelect = (selectedFilter) => {
        this.setState({
            selectedSpeakersFilter: selectedFilter,
        })
    }

    closeModal = () => {
        this.setState({
            showSpeakerFilters: false,
        })
    }

    render() {
        const { activityList, activityFilterList, sessionDays, speakerList, actTracks, actTypes, loading, showGridView, searchTerm, showSpeakerFilters, selectedSpeakersFilter } = this.state;
        // const eventLogoPicture = getPictureHandlerUrl(this.state.logoPictureId);
        const eventLogoPicture = getPictureOrTransparent(this.state.logoPictureId);

        const activitiesToRender = this.handleFilterAndSearch();
        return (
            <div id="SessionByDayView">
                {
                    activityList.length == 0 && loading == true
                        ?
                        <Spinner animation="border" role="status" />
                        :
                        <>
                            {
                                showSpeakerFilters &&
                                <SpeakerFilters speakerList={speakerList} selectedList={selectedSpeakersFilter} updateSelectedList={this.handleSpeakerFilterSelect} closeModal={this.closeModal} />
                            }
                            <div className='programme-header'>
                                {
                                    eventLogoPicture &&
                                    <div className='programme-logo-wrapper'>
                                        <img src={eventLogoPicture} alt='event logo' />
                                    </div>
                                }

                                <div className='filters-wrapper'>
                                    <div>
                                        <h3 className='search-title'>Buscar por título</h3>
                                        <div className='textSearchPanel'>
                                            <input type='text' placeholder='Buscar...' className='searchBar' value={searchTerm} onChange={this.handleSearchBar} />
                                        </div>
                                    </div>
                                    <div id="trackSearchPanel">
                                        <h3><IntlMessages id="dashboards.trackSearch" /></h3>
                                        <Multiselect
                                            options={actTracks.sort((a, b) => a.name > b.name)} // Options to display in the dropdown
                                            displayValue={this._getDisplayValueOptionForFilter()} // Property name to display in the dropdown options
                                            avoidHighlightFirstOption={true}
                                            hidePlaceholder={true}
                                            placeholder={this.props.locale == "es" ? "Buscar por tema" : "Search by track"}
                                            emptyRecordMsg={this.props.locale == "es" ? "No hay opciones" : "No options available"}
                                            onSelect={this._handleTrackFilterSelect}
                                            onRemove={this._handleTrackFilterSelect}
                                        />
                                    </div>
                                    <div id="typeSearchPanel">
                                        <h3><IntlMessages id="dashboards.typeSearch" /></h3>
                                        <Multiselect
                                            options={actTypes.sort((a, b) => a.name > b.name)} // Options to display in the dropdown
                                            displayValue={this._getDisplayValueOptionForFilter()} // Property name to display in the dropdown options
                                            avoidHighlightFirstOption={true}
                                            hidePlaceholder={true}
                                            placeholder={this.props.locale == "es" ? "Buscar por tipo" : "Search by type"}
                                            emptyRecordMsg={this.props.locale == "es" ? "No hay opciones" : "No options available"}
                                            onSelect={this._handleTypeFilterSelect}
                                            onRemove={this._handleTypeFilterSelect}
                                        />
                                    </div>
                                </div>
                                <div className='button-wrapper'>
                                    <div className='viewStyleSwitchWrapper'>
                                        <button onClick={() => this.setState({ showSpeakerFilters: true })} className='viewStyleSwitch' >{'Filtrar por Orador'}</button>
                                    </div>
                                    <div className='viewStyleSwitchWrapper'>
                                        <button onClick={() => this.setState({ showGridView: !showGridView })} className='viewStyleSwitch' >{showGridView ? 'Cambiar a detalles' : 'Cambiar a grilla'}</button>
                                    </div>
                                </div>
                            </div>
                        </>
                }
                <br />
                <Tabs defaultActiveKey={this.state.daysWithActivities[0]} >
                    {
                        sessionDays.map(day => {
                            const activityNumber = this._getActivitiesForTheDay(day, activitiesToRender).length;
                            // if (!activityNumber) {
                            //     return <></>
                            // }

                            return (
                                <Tab key={day} eventKey={day} title={this._getDateForSessionByDay(day)} tabClassName={'session-tab'}>
                                    {
                                        activityNumber === 0 ?
                                            <span>No hay actividades para mostrar...</span>
                                            :
                                            <>
                                                {
                                                    showGridView
                                                        ?
                                                        <ProgrammeGridView
                                                            activities={this._getActivitiesForTheDay(day, activitiesToRender)}
                                                            trackData={actTracks}
                                                            activitiesList={activityList}
                                                            speakersList={speakerList}
                                                            typesData={actTypes}
                                                        />
                                                        :
                                                        <SessionByDay
                                                            key={new Date(day).getDate()}
                                                            onlyNoParentActivities={true}
                                                            clickAction={(activity, topHeight, roomLink) => this._performClickAction(activity, topHeight, roomLink)}
                                                            speakers={speakerList}
                                                            allActivities={activityList}
                                                            actsArray={activitiesToRender}
                                                            actTracks={actTracks}
                                                            actTypes={actTypes}
                                                            day={day} />
                                                }
                                            </>
                                    }
                                </Tab>
                            )
                        }
                        )}
                </Tabs>
            </div>)
    }
}

const mapStateToProps = state => {
    return { locale: state.settings.locale }
}

export default connect(mapStateToProps, null)(withRouter(Sessions))
